<template>
  <div class="choosen-order__aeroexpress-wrapper">
    <div>
      <div class="choose-order__aeroexpress-header__wrapper">
        <div class="choose-order__aeroexpress-company">
          <div class="choose-order__aeroexpress-company__logo">
            <img
              :src="
                require(`../assets/images/companies/aeroexpress-icon-logo.svg`)
              "
              alt="Aeroexpress icon"
              class="choose-order__aeroexpress-company__logo-img"
            />
          </div>
          <div class="choose-order__aeroexpress-company__info">
            <div class="choose-order__aeroexpress-company__info-name">
              Аэроэкспресс
            </div>
            <!-- <div
            v-if="this.isDateMoreThanToday(info.Time)"
            class="choose-order__aeroexpress-company__info-duration"
          >
            {{
              getHoursTimeInFlight(this.schedule.aeroexpressFromTravelTime) +
              "ч " +
              getMinutesTimeInFlight(this.schedule.aeroexpressFromTravelTime) +
              "м в пути"
            }}
          </div> -->
          </div>
        </div>
        <router-link
          v-if="this.isDateMoreThanToday(info.Time)"
          :to="{
            name: 'AeroExpressSchedule',
            params: {
              time: info.Time,
              codeArr: info.CodeArr,
              codeDep: info.CodeDep,
              codeDepRus: info.CodeDepRus,
              codeArrRus: info.CodeArrRus,
              nameArr: info.NameArr,
              nameDep: info.NameDep,
              arrId: info.ArrId,
              depId: info.DepId,
            },
          }"
          data-num="passengers"
          class="passengers-card"
        >
          <Button
            label="Расписание"
            class="
              p-button-outlined p-button-sm
              choosen-order__aeroexpress-info__btn
            "
          />
        </router-link>
      </div>
      <div class="choosen-order__aeroexpress-route">
        <div class="choosen-order__aeroexpress-route__scheme">
          <div class="choosen-order__aeroexpress-route__scheme-marker"></div>
          <div class="choosen-order__aeroexpress-route__scheme-connector"></div>
          <div class="choosen-order__aeroexpress-route__scheme-marker"></div>
        </div>
        <div
          v-if="this.isDateMoreThanToday(info.Time)"
          class="choosen-order__aeroexpress-route__dates"
        >
          <div v-if="info.DepTime !== null">
            <div class="choosen-order__aeroexpress-route__dates-departure">
              <div
                class="choosen-order__aeroexpress-route__dates-departure__time"
              >
                {{ getTime(info.DepTime) }}
              </div>
              <div
                class="choosen-order__aeroexpress-route__dates-departure__date"
              >
                {{ getDate(info.DepTime) + ", " + getWeekDay(info.DepTime) }}
              </div>
            </div>
            <div class="choosen-order__aeroexpress-route__dates-arrival">
              <div
                class="choosen-order__aeroexpress-route__dates-arrival__time"
              >
                {{ getTime(info.ArrTime) }}
              </div>
              <div
                class="choosen-order__aeroexpress-route__dates-arrival__date"
              >
                {{ getDate(info.ArrTime) + ", " + getWeekDay(info.ArrTime) }}
              </div>
            </div>
          </div>
          <div
            v-else
            class="choosen-order__aeroexpress-route__dates-withouttime"
          >
            <div class="choosen-order__aeroexpress-route__dates-departure">
              <div
                class="choosen-order__aeroexpress-route__dates-arrival__date"
              >
                {{ getDate(info.Time) + ", " + getWeekDay(info.Time) }}
              </div>
            </div>
            <div class="choosen-order__aeroexpress-route__dates-arrival-old">
              <div
                class="choosen-order__aeroexpress-route__dates-arrival__date"
              >
                {{ getDate(info.Time) + ", " + getWeekDay(info.Time) }}
              </div>
            </div>
          </div>
        </div>
        <div v-else class="choosen-order__aeroexpress-route__dates">
          <div class="choosen-order__aeroexpress-route__dates-departure">
            <div class="choosen-order__aeroexpress-route__dates-arrival__date">
              {{ getDate(info.Time) + ", " + getWeekDay(info.Time) }}
            </div>
          </div>
          <div class="choosen-order__aeroexpress-route__dates-arrival-old">
            <div class="choosen-order__aeroexpress-route__dates-arrival__date">
              {{ getDate(info.Time) + ", " + getWeekDay(info.Time) }}
            </div>
          </div>
        </div>
        <div class="choosen-order__aeroexpress-route__citys">
          <div class="choosen-order__aeroexpress-route__citys-departure">
            <div
              class="choosen-order__aeroexpress-route__citys-departure__city"
            >
              {{ info.NameDep }}
            </div>
          </div>
          <div class="choosen-order__aeroexpress-route__citys-arrival">
            <div class="choosen-order__aeroexpress-route__citys-arrival__city">
              {{ info.NameArr }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "@vue/runtime-core";
import Button from "primevue/button";

export default defineComponent({
  name: "Routeaeroexpress",
  components: {
    Button,
  },
  props: ["info", "schedule"],
  data() {
    return {
      visibleFull: false,
      hoursWords: ["час", "часа", "часов"],
      minutesWords: ["минута", "минуты", "минут"],
      activeOrder: this.$route.params,
      month: [
        "янв",
        "фев",
        "мар",
        "апр",
        "мая",
        "июн",
        "июл",
        "авг",
        "сен",
        "окт",
        "ноя",
        "дек",
      ],
    };
  },
  methods: {
    isDateMoreThanToday(date: any): boolean {
      let today = new Date();
      let routeDate = new Date(date);
      if (today > routeDate) {
        return false;
      } else {
        return true;
      }
    },
    getTimeOfRoute(depDate: any, arrDate: any) {
      let depTime = new Date(depDate);
      let arrTime = new Date(arrDate);
      let diffCount: any = depTime.valueOf() - arrTime.valueOf();
      let finalHours = Math.floor((diffCount % 86400000) / 3600000);
      let finalMinutes = Math.floor(((diffCount % 86400000) % 3600000) / 60000);
      return finalHours + "ч " + finalMinutes + "м в пути";
    },
    getHoursTimeInFlight(time: any) {
      let flightHours = 0;
      let splited = time.split(":");
      flightHours += +splited[0];
      return flightHours;
    },
    getMinutesTimeInFlight(time: any) {
      let flightMinutes = 0;
      let splited = time.split(":");
      flightMinutes += +splited[1];
      return flightMinutes;
    },
    getHoursTransferTime(depTrans: any, arrTrans: any) {
      let depTime = new Date(depTrans);
      let arrTime = new Date(arrTrans);
      let diffCount: any = depTime.valueOf() - arrTime.valueOf();
      let finalHours = Math.floor((diffCount % 86400000) / 3600000);
      let finalMinutes = Math.round(((diffCount % 86400000) % 3600000) / 60000);
      return finalHours + "ч " + finalMinutes + "м";
    },
    declOfHours(number: any, words: any) {
      return words[
        number % 100 > 4 && number % 100 < 20
          ? 2
          : [2, 0, 1, 1, 1, 2][number % 10 < 5 ? Math.abs(number) % 10 : 5]
      ];
    },
    hide() {
      this.$emit("update:visible", false);
    },
    getWeekDay(date: any) {
      let days = ["вс", "пн", "вт", "ср", "чт", "пт", "сб"];
      let weekDay = new Date(date);
      return days[weekDay.getDay()];
    },
    getDate(date: any) {
      let month = [
        "янв",
        "фев",
        "мар",
        "апр",
        "мая",
        "июн",
        "июл",
        "авг",
        "сен",
        "окт",
        "ноя",
        "дек",
      ];
      let monthNum = new Date(date);
      return monthNum.getDate() + " " + month[monthNum.getMonth()];
    },
    getAnyDate(date: any) {
      let created: any = new Date(date);
      let createdDay = created.getDate();
      let createdMonth: any = created.getMonth();
      let createdYear = created.getFullYear();
      let createdHours = function () {
        if (created.getHours() < 10) {
          return "0" + created.getHours();
        } else {
          return created.getHours();
        }
      };
      let createdMinutes = function () {
        if (created.getMinutes() < 10) {
          return "0" + created.getMinutes();
        } else {
          return created.getMinutes();
        }
      };
      return (
        createdDay +
        " " +
        this.month[createdMonth] +
        " " +
        createdYear +
        " " +
        createdHours() +
        ":" +
        createdMinutes()
      );
    },
    getTime(date: any) {
      let time = new Date(date);
      let hours = time.getHours();
      let minutes = time.getMinutes();
      if (minutes < 10) {
        return hours + ":0" + minutes;
      }
      return hours + ":" + minutes;
    },
    getHours(date: any) {
      let time = date.split(":");
      let hours = time[0];
      return hours;
    },
    getMinutes(date: any) {
      let time = date.split(":");
      let minutes = time[1];
      return minutes;
    },
    getCompanyLogo(company: any) {
      return `"@/assets/images/companies/${company}.svg"`;
    },
  },
});
</script>

<style>
.choose-order__aeroexpress-header__wrapper {
  display: flex;
  justify-content: space-between;
}

.choosen-order__aeroexpress-route__dates-withouttime {
  margin-top: 5px;
  margin-left: 0px;
}

@media screen and (max-width: 767px) {
  .choosen-order__aeroexpress-wrapper {
    align-items: center;
  }

  .choose-order__aeroexpress-company {
    display: flex;
    align-items: center;
  }

  .choose-order__aeroexpress-company__info {
    margin-left: 10px;
  }

  .choose-order__aeroexpress-company__info-name {
    font-weight: 500;
    font-style: normal;
    font-size: 16px;
  }

  .choose-order__aeroexpress-company__info-duration {
    font-weight: 500;
    font-style: normal;
    font-size: 14px;
    color: #666666;
  }

  .rule-hint {
    color: cornflowerblue;
    text-decoration: underline;
  }

  .rule-hint[original-title]:hover::before {
    content: attr(original-title);
    position: absolute;
    left: 0;
    bottom: 0px;
    display: inline-block;
    padding: 3px 6px;
    border-radius: 2px;
    background: rgb(138, 204, 243);
    color: #000;
    font-size: 12px;
    min-width: 250px;
    font-family: sans-serif;
    white-space: normal;
    z-index: 5;
  }

  .choosen-order__aeroexpress-route {
    display: flex;
    margin-bottom: 20px;
    margin-top: 10px;
  }

  .choosen-order__aeroexpress-route__scheme {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    margin-top: 15px;
  }

  .choosen-order__aeroexpress-route__scheme-marker {
    width: 1rem;
    height: 1rem;
    border: 5px solid #9e9e9e;
    border-radius: 50%;
    color: #9e9e9e;
  }

  .choosen-order__aeroexpress-route__scheme-connector {
    width: 2px;
    min-height: 50px;
    max-height: 50px;
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
    background-color: #9e9e9e;
  }

  .choosen-order__aeroexpress-route__dates {
    margin-top: 13px;
    margin-left: 25px;
  }

  .choosen-order__aeroexpress-route__dates-departure__time {
    font-weight: 500;
    font-style: normal;
    font-size: 18px;
    line-height: 18px;
  }

  .choosen-order__aeroexpress-route__dates-departure__date {
    font-weight: 500;
    font-style: normal;
    font-size: 14px;
    line-height: 14px;
    color: #666666;
    margin-top: 5px;
  }

  .choosen-order__aeroexpress-route__dates-arrival {
    margin-top: 30px;
  }

  .choosen-order__aeroexpress-route__dates-arrival-old {
    margin-top: 50px;
  }

  .choosen-order__aeroexpress-route__dates-arrival__time {
    font-weight: 500;
    font-style: normal;
    font-size: 18px;
    line-height: 18px;
  }

  .choosen-order__aeroexpress-route__dates-arrival__date {
    font-weight: 500;
    font-style: normal;
    font-size: 14px;
    line-height: 14px;
    color: #666666;
    margin-top: 5px;
  }

  .choosen-order__aeroexpress-route__citys {
    margin-top: 13px;
    margin-left: 25px;
  }

  .choosen-order__aeroexpress-route__citys-departure__city {
    font-weight: 500;
    font-style: normal;
    font-size: 18px;
    line-height: 18px;
  }

  .choosen-order__aeroexpress-route__citys-departure__airport {
    font-weight: 500;
    font-style: normal;
    font-size: 14px;
    line-height: 14px;
    color: #666666;
    margin-top: 5px;
  }

  .choosen-order__aeroexpress-route__citys-arrival {
    margin-top: 48px;
  }

  .choosen-order__aeroexpress-route__citys-arrival__city {
    font-weight: 500;
    font-style: normal;
    font-size: 18px;
    line-height: 18px;
  }

  .choosen-order__aeroexpress-route__citys-arrival__airport {
    font-weight: 500;
    font-style: normal;
    font-size: 14px;
    line-height: 14px;
    color: #666666;
    margin-top: 5px;
  }

  .choosen-order__aeroexpress-info__wrapper {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .choose-order__aeroexpress-company__logo-img {
    max-height: 30px;
    max-width: 30px;
    border-radius: 50%;
  }
}

@media screen and (min-width: 768px) and (max-width: 1024px) {
  .choosen-order__aeroexpress-wrapper {
    align-items: center;
  }

  .choose-order__aeroexpress-company {
    display: flex;
    align-items: center;
  }

  .choose-order__aeroexpress-company__info {
    margin-left: 10px;
  }

  .choose-order__aeroexpress-company__info-name {
    font-weight: 500;
    font-style: normal;
    font-size: 16px;
  }

  .choose-order__aeroexpress-company__info-duration {
    font-weight: 500;
    font-style: normal;
    font-size: 14px;
    color: #666666;
  }

  .rule-hint {
    color: cornflowerblue;
    text-decoration: underline;
  }

  .rule-hint[original-title]:hover::before {
    content: attr(original-title);
    position: absolute;
    left: 0;
    bottom: 0px;
    display: inline-block;
    padding: 3px 6px;
    border-radius: 2px;
    background: rgb(138, 204, 243);
    color: #000;
    font-size: 12px;
    min-width: 250px;
    font-family: sans-serif;
    white-space: normal;
    z-index: 5;
  }

  .choosen-order__aeroexpress-route {
    display: flex;
    margin-bottom: 20px;
    margin-top: 10px;
  }

  .choosen-order__aeroexpress-route__scheme {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    margin-top: 15px;
  }

  .choosen-order__aeroexpress-route__scheme-marker {
    width: 1rem;
    height: 1rem;
    border: 5px solid #9e9e9e;
    border-radius: 50%;
    color: #9e9e9e;
  }

  .choosen-order__aeroexpress-route__scheme-connector {
    width: 2px;
    min-height: 50px;
    max-height: 50px;
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
    background-color: #9e9e9e;
  }

  .choosen-order__aeroexpress-route__dates {
    margin-top: 13px;
    margin-left: 25px;
  }

  .choosen-order__aeroexpress-route__dates-departure__time {
    font-weight: 500;
    font-style: normal;
    font-size: 18px;
    line-height: 18px;
  }

  .choosen-order__aeroexpress-route__dates-departure__date {
    font-weight: 500;
    font-style: normal;
    font-size: 14px;
    line-height: 14px;
    color: #666666;
    margin-top: 5px;
  }

  .choosen-order__aeroexpress-route__dates-arrival {
    margin-top: 30px;
  }

  .choosen-order__aeroexpress-route__dates-arrival-old {
    margin-top: 50px;
  }

  .choosen-order__aeroexpress-route__dates-arrival__time {
    font-weight: 500;
    font-style: normal;
    font-size: 18px;
    line-height: 18px;
  }

  .choosen-order__aeroexpress-route__dates-arrival__date {
    font-weight: 500;
    font-style: normal;
    font-size: 14px;
    line-height: 14px;
    color: #666666;
    margin-top: 5px;
  }

  .choosen-order__aeroexpress-route__citys {
    margin-top: 13px;
    margin-left: 25px;
  }

  .choosen-order__aeroexpress-route__citys-departure__city {
    font-weight: 500;
    font-style: normal;
    font-size: 18px;
    line-height: 18px;
  }

  .choosen-order__aeroexpress-route__citys-departure__airport {
    font-weight: 500;
    font-style: normal;
    font-size: 14px;
    line-height: 14px;
    color: #666666;
    margin-top: 5px;
  }

  .choosen-order__aeroexpress-route__citys-arrival {
    margin-top: 48px;
  }

  .choosen-order__aeroexpress-route__citys-arrival__city {
    font-weight: 500;
    font-style: normal;
    font-size: 18px;
    line-height: 18px;
  }

  .choosen-order__aeroexpress-route__citys-arrival__airport {
    font-weight: 500;
    font-style: normal;
    font-size: 14px;
    line-height: 14px;
    color: #666666;
    margin-top: 5px;
  }

  .choosen-order__aeroexpress-info__wrapper {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .choose-order__aeroexpress-company__logo-img {
    max-height: 30px;
    max-width: 30px;
    border-radius: 50%;
  }
}

@media screen and (min-width: 1025px) {
  .choosen-order__aeroexpress-wrapper {
    align-items: center;
  }

  .choose-order__aeroexpress-company {
    display: flex;
    align-items: center;
  }

  .choose-order__aeroexpress-company__info {
    margin-left: 10px;
  }

  .choose-order__aeroexpress-company__info-name {
    font-weight: 500;
    font-style: normal;
    font-size: 16px;
  }

  .choose-order__aeroexpress-company__info-duration {
    font-weight: 500;
    font-style: normal;
    font-size: 14px;
    color: #666666;
  }

  .rule-hint {
    color: cornflowerblue;
    text-decoration: underline;
  }

  .rule-hint[original-title]:hover::before {
    content: attr(original-title);
    position: absolute;
    left: 0;
    bottom: 0px;
    display: inline-block;
    padding: 3px 6px;
    border-radius: 2px;
    background: rgb(138, 204, 243);
    color: #000;
    font-size: 12px;
    min-width: 250px;
    font-family: sans-serif;
    white-space: normal;
    z-index: 5;
  }

  .choosen-order__aeroexpress-route {
    display: flex;
    margin-bottom: 20px;
    margin-top: 10px;
  }

  .choosen-order__aeroexpress-route__scheme {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    margin-top: 15px;
  }

  .choosen-order__aeroexpress-route__scheme-marker {
    width: 1rem;
    height: 1rem;
    border: 5px solid #9e9e9e;
    border-radius: 50%;
    color: #9e9e9e;
  }

  .choosen-order__aeroexpress-route__scheme-connector {
    width: 2px;
    min-height: 50px;
    max-height: 50px;
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
    background-color: #9e9e9e;
  }

  .choosen-order__aeroexpress-route__dates {
    margin-top: 13px;
    margin-left: 25px;
  }

  .choosen-order__aeroexpress-route__dates-departure__time {
    font-weight: 500;
    font-style: normal;
    font-size: 18px;
    line-height: 18px;
  }

  .choosen-order__aeroexpress-route__dates-departure__date {
    font-weight: 500;
    font-style: normal;
    font-size: 14px;
    line-height: 14px;
    color: #666666;
    margin-top: 5px;
  }

  .choosen-order__aeroexpress-route__dates-arrival {
    margin-top: 30px;
  }

  .choosen-order__aeroexpress-route__dates-arrival-old {
    margin-top: 50px;
  }

  .choosen-order__aeroexpress-route__dates-arrival__time {
    font-weight: 500;
    font-style: normal;
    font-size: 18px;
    line-height: 18px;
  }

  .choosen-order__aeroexpress-route__dates-arrival__date {
    font-weight: 500;
    font-style: normal;
    font-size: 14px;
    line-height: 14px;
    color: #666666;
    margin-top: 5px;
  }

  .choosen-order__aeroexpress-route__citys {
    margin-top: 13px;
    margin-left: 25px;
  }

  .choosen-order__aeroexpress-route__citys-departure__city {
    font-weight: 500;
    font-style: normal;
    font-size: 18px;
    line-height: 18px;
  }

  .choosen-order__aeroexpress-route__citys-departure__airport {
    font-weight: 500;
    font-style: normal;
    font-size: 14px;
    line-height: 14px;
    color: #666666;
    margin-top: 5px;
  }

  .choosen-order__aeroexpress-route__citys-arrival {
    margin-top: 48px;
  }

  .choosen-order__aeroexpress-route__citys-arrival__city {
    font-weight: 500;
    font-style: normal;
    font-size: 18px;
    line-height: 18px;
  }

  .choosen-order__aeroexpress-route__citys-arrival__airport {
    font-weight: 500;
    font-style: normal;
    font-size: 14px;
    line-height: 14px;
    color: #666666;
    margin-top: 5px;
  }

  .choosen-order__aeroexpress-info__wrapper {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .choose-order__aeroexpress-company__logo-img {
    max-height: 30px;
    max-width: 30px;
    border-radius: 50%;
  }
}
</style>
